import { Injectable } from '@angular/core';
import { ItemBusquedaModel } from '../utilidades.modelos.index';
import { UtilidadesService } from '../utilidades.servicios.index';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CallesService {

	constructor(
		private Utilidades: UtilidadesService
	) { }

	public Lista(otrasLocalidades: boolean = false): Observable<ItemBusquedaModel[]> {
		return this.Utilidades.Get("Externos/Calles/" + otrasLocalidades);
	}

	public Obtener(idCalle: string, idLocalidad: string): Observable<ItemBusquedaModel> {
		return this.Utilidades.Get("Externos/Calles/Obtener/" + idCalle + "/" + idLocalidad);
	}
}
